module.exports = __webpack_public_path__ + "static/media/YF28_0.de1b70bf.jpg";